import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { AddCommentPayload } from "../../payload/AddComment/AddCommentPayload";

const addCommentFecth = (state: ClientsState, actions: PayloadAction<AddCommentPayload>) => {
    state.isLoading = true;
}

export default addCommentFecth;